"use client";

import { forwardRef, type InputHTMLAttributes, useState } from "react";
import { PasswordRevealButton } from "./PasswordRevealButton";

// Auth-surface password field: the inline auth input recipe (h-10, white,
// 1px --line border, squared) plus an in-field reveal toggle. forwardRef +
// prop spread so it drops into a RHF `{...register("password")}` call
// exactly where the bare <input> used to live, inside the form's <Field>.
// `pr-10` reserves room for the 40px reveal button. The portal surface
// uses `TextInput` (its own recipe) for the same effect — both share
// `PasswordRevealButton`.
type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const PasswordInput = forwardRef<HTMLInputElement, Props>(function PasswordInput(
  { className, ...rest },
  ref,
) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={revealed ? "text" : "password"}
        className={`h-10 w-full pl-3.5 pr-10 border bg-[color:var(--color-card)] ${className ?? ""}`}
        style={{ borderColor: "var(--color-line)" }}
        {...rest}
      />
      <PasswordRevealButton revealed={revealed} onToggle={() => setRevealed((v) => !v)} />
    </div>
  );
});
